<script>
  export let call_status

  const url = "https://us-central1-ccaas-untangl.cloudfunctions.net/twilio"
  // const url = "http://localhost:8000/token"

  let DEVICE; //twilio device
  export let intervalId
  export let mode;

  $: if(mode=="phone"){
      // console.log(mode)
      start_call()
  }


  let dots = 3

  // Twilio Callbacks
  const errorMsg=(e)=>{
    console.log(e)
  }

  const ready=(device)=>{
    // console.log('ready')
    device.connect({
      demo: "Eyeglasses"
    })

    // console.log(connection)
  }

  const offline=(device)=>{
    // console.log(device)
    console.log('offline')
  }

  const connect=(connection)=>{
    
    // console.log('connect')
    clearInterval(intervalId);
    call_status = "connected"
  }

  const disconnect=(connection)=>{
    // console.log('disconnect')
    clearInterval(intervalId);
    call_status = "call ended"
  }

  const cancelled=(connection)=>{
    // console.log('cancel')
  }

  const handle_call=()=>{
      clearInterval(intervalId);
      (call_status === "call ended") ? start_call(): call_status = "call ended" && DEVICE.disconnectAll()
      // device.disconnectAll()
        // device.destroy()
    }

  const start_call=()=>{
    mode = "phone"
    // console.log(mode)
    intervalId = setInterval(function () {
      // console.log(dots)
      dots == 3 ? dots =0 : dots++
      switch (dots) {
        case 3:
          call_status = "calling..."
          break;
        case 2:
          call_status = "calling.."
          break;
        case 1:
          call_status = "calling."
          break;
      
        default:
          call_status = "calling"
          break;
      }
    }, 500);

    let twilToken;
    
    DEVICE = new Twilio.Device();
    DEVICE.on('error', errorMsg)
    DEVICE.on('ready', ready)
    DEVICE.on('offline', offline)
    DEVICE.on('connect', connect)
    DEVICE.on('disconnect', disconnect)
    DEVICE.on('cancel', cancelled)

    fetch(url).then(res=>res.json()).then(data=>{
      twilToken = data.token
      // console.log(twilToken)
      // console.log('handlers set')
      DEVICE.setup(twilToken);
      // console.log(DEVICE)
      
    })
  }
 </script>
 
 <!-- Phone interface -->
 <div class="flex flex-col h-full items-center justify-evenly bg-white rounded-md">
  <div class="flex flex-col items-center justify-center">
    <p class="text-lg text-center font-medium">Untangl Eyeglass Support Center</p>
    <p>+1 844 973 4682</p>
    <!-- Status -->
    <p>{call_status}</p>
  </div>
  <div>
    <div class={`transition-all rounded-full p-4 mt-26 cursor-pointer ${(call_status!="call ended"||call_status=="connected")? "bg-red-500":"bg-emerald-500 -rotate-180"}`} on:click={handle_call}>
      <img class="h-16" src="img/call_end.svg" alt="hangup"/>
    </div>
  </div>
</div>